export const NekoColors = {
  black: 'var(--neko-black)',
  blackRGB: 'var(--neko-black-rgb)',
  blue: 'var(--block-background)',
  blueRGB: 'var(--block-background-rgb)',
  blueDisabled: 'var(--block-background-disabled)',
  deepBlue: 'var(--neko-deep-blue)',
  deepBlueDisabled: 'var(--neko-deep-blue-disabled)',
  finderBorder: 'var(--neko-finder-border)',
  lightBlue: 'var(--neko-light-blue)',
  lightBlue2: 'var(--neko-light-blue2)',
  mediumBlue: 'hsl(var(--neko-medium-blue))',
  lightGray: 'var(--neko-light-gray)',
  lightPurple: 'var(--neko-light-purple)',
  gray: 'var(--neko-gray)',
  green: 'var(--neko-green)',
  darkGray: 'var(--neko-dark-gray)',
  disabledForm: 'var(--neko-disabled-form)',
  orange: 'var(--neko-orange)',
  overlay: 'rgba(var(--neko-overlay))',
  red: 'var(--neko-red)',
  redHighlight: 'var(--neko-red-highlight)',
  header: 'var(--neko-header)',
  proGray: 'var(--neko-pro-gray)',
  progress: 'var(--neko-progress)',
  purple: 'var(--neko-purple)',
  tableGray: 'var(--neko-table-gray)',
  yellow: 'var(--neko-yellow)',
  yellowRGB: 'var(--neko-yellow-rgb)',
  white: 'var(--neko-white)',
  whiteRGB: 'var(--neko-whiteRGB)',

  // NEW NEKO 2.0
  inputBackground: 'var(--neko-input-background)',
}

export const NekoColorTheme = {
  danger: NekoColors.red,
  primary: NekoColors.blue,
  secondary: NekoColors.lightBlue,
  success: NekoColors.green,
}

const NekoTheme = {

  // COLORS
  // ...NekoColors,
  ...NekoColorTheme,

  // FONT

  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell,"Helvetica Neue", sans-serif',
  fontSizeH1: '24px',
  fontSizeH2: '18px',
  fontSizeText: '13px',
  fontSizeSmall: '12px',
  fontSizeSmallButton: '10px',

  // SHADOW

  lightShadow: '0px 0px 10px rgba(0,0,0,0.1)',
};

export default NekoTheme;
